import {theme} from "../theme";


export const calculateColor = (type) => theme.colors[type]